/* ----------------------- PDP ----------------------- */
/* ----- text-with-icons-variants ----- */
// let productInfo = document.querySelector('product-info')
// let customVariantPickerRadios = productInfo.querySelector('variant-radios')
// let customVariantPickerSelects = productInfo.querySelector('variant-selects')
// let variantDetailsContainer = productInfo.querySelector('.icon-with-text__variant-wrapper')
// let variantDetailsEls = productInfo.querySelectorAll('.icon-with-text__variant')

// if (variantDetailsContainer && customVariantPickerRadios) {
//   customVariantPickerRadios.addEventListener('change', () => {
//     setTimeout(customUpdateDescription, 300)
//   })
// }

// if (variantDetailsContainer && customVariantPickerSelects) {
//   customVariantPickerSelects.addEventListener('change', () => {
//     setTimeout(customUpdateDescription, 300)
//   })
// }
  
// function customUpdateDescription() {
//   const queryString = window.location.search;
//   const urlParams = new URLSearchParams(queryString);
//   const currentVariantId = urlParams.get('variant')

//   variantDetailsEls.forEach(el => el.classList.remove('active'));
//   variantDetailsContainer.querySelector(`.icon-with-text__variant[data-variant-id="${currentVariantId}"]`).classList.add('active')
// }

// ------------------------------------------------------------------
// ------------------------------------------------------------------
// ------------------------------------------------------------------

class ProductInfoMetafieldUpdate {
  constructor(element) {
    this.productInfo = element;

    if (this.productInfo) {
      this.customVariantPickerRadios = this.productInfo.querySelector('variant-radios');
      this.customVariantPickerSelects = this.productInfo.querySelector('variant-selects');
      this.variantDetailsContainer = this.productInfo.querySelector('.icon-with-text__variant-wrapper');
      this.variantDetailsEls = this.productInfo.querySelectorAll('.icon-with-text__variant');
      this.formEl = this.productInfo.querySelector('form');
      this.formIdIn = this.formEl.querySelector('input[name="id"]');

      this.tableVariantDetailsEls = document.querySelectorAll('.shopify-section--table-variant-details');

      this.attachEvents();
    }
  }

  attachEvents() {
    if (this.customVariantPickerRadios && this.variantDetailsEls) {
      this.customVariantPickerRadios.addEventListener('change', () => {
        this.updateVariantDescription();
        
        if (this.tableVariantDetailsEls) {
          this.updateTableVariantRow()
        }
      });
    }

    if (this.customVariantPickerSelects && this.variantDetailsEls) {
      this.customVariantPickerSelects.addEventListener('change', () => {
        this.updateVariantDescription();

        if (this.ableVariantDetailsEls) {
          this.updateTableVariantRow()
        }
      });
    }
  }

  updateVariantDescription() {
    const currentVariantId = this.formIdIn.value;
    let activeVariant;

    this.variantDetailsEls.forEach(el => el.classList.remove('active'));
    if (this.variantDetailsContainer){
      activeVariant = this.variantDetailsContainer.querySelector(`[data-variant-id="${currentVariantId}"]`); 
    }    
    if (activeVariant) {
      activeVariant.classList.add('active');
    }
  }

  updateTableVariantRow() {
    const currentVariantId = this.formIdIn.value;
    
    this.tableVariantDetailsEls.forEach(el => {
        let table = el.querySelector('table')
        let tableBodyRows = table.querySelectorAll('.table-variant-details__row[data-variant-id]')
      
        tableBodyRows.forEach(el => el.classList.remove('active'));
        const activeVariantRow = table.querySelector(`[data-variant-id="${currentVariantId}"]`);
        if (activeVariantRow) {
          activeVariantRow.classList.add('active');
        }
      }
    );
  }
  
}

// Usage
document.addEventListener('DOMContentLoaded', () => {
  let productInfoEl = document.querySelector('.product__info-wrapper product-info');
  if (productInfoEl) {
    new ProductInfoMetafieldUpdate(productInfoEl);
  }
});
